/**
 * Cihaz taslağı (PDF §13). Durumlar:
 * LOCAL_DRAFT → UPLOADING → OCR_PENDING → REVIEW_REQUIRED | READY → SUBMITTING → POSTED | FAILED
 * "Kaydedildi" yalnızca sunucu fiş kimliği geldiğinde (POSTED) gösterilir. Çevrimdışı iken
 * kesin kayıt ve ortak toplam DEĞİŞMEZ. İptal/iade/düzenleme çevrimdışı kuyruğa alınmaz.
 */
import type { PaymentMethod } from '../api/types';

export type LocalState =
  | 'LOCAL_DRAFT' | 'UPLOADING' | 'OCR_PENDING' | 'REVIEW_REQUIRED' | 'READY' | 'SUBMITTING' | 'POSTED' | 'FAILED';

export interface DraftImage {
  id: string;
  name: string;
  mime: string;
  size: number;
  sha256: string;
  uploadedFileId: string | null; // sunucuya yüklendiyse
}

export interface DraftFields {
  amount: string;           // kullanıcı girişi (Türkçe biçim); gönderimde kanonik metne çevrilir
  document_date: string;    // YYYY-MM-DD
  document_time: string;    // HH:MM veya HH:MM:SS ya da ''
  vendor_name: string;
  vendor_tax_no: string;
  document_no: string;
  category: string;
  description: string;
  payment_method: PaymentMethod | '';  // elle seçilir; fişten okunmaz
  payment_due_date: string;            // YYYY-MM-DD; yalnızca veresiyede
}

export interface Draft {
  id: string;               // client_draft_id: kamera açılmadan oluşturulur
  userId: string;           // hesap değişiminde başka kişinin taslağı görünmez (T22)
  state: LocalState;
  fields: DraftFields;
  images: DraftImage[];
  candidateId: string | null;
  candidateVersion: number | null;
  createIdempotencyKey: string;
  submitIdempotencyKey: string; // aynı taslağın yeniden gönderimi aynı anahtarı kullanır (T08)
  receiptId: string | null;
  lastError: { code: string; message: string } | null;
  createdAt: number;
  updatedAt: number;
  attempts: number;
  nextAttemptAt: number;
}

export const emptyFields = (): DraftFields => ({
  amount: '', document_date: '', document_time: '', vendor_name: '', vendor_tax_no: '',
  document_no: '', category: '', description: '', payment_method: '', payment_due_date: '',
});

export interface DraftStore {
  list(userId: string): Promise<Draft[]>;
  get(id: string): Promise<Draft | undefined>;
  put(draft: Draft): Promise<void>;
  remove(id: string): Promise<void>;
  putImage(draftId: string, imageId: string, blob: Blob): Promise<void>;
  getImage(draftId: string, imageId: string): Promise<Blob | undefined>;
  removeImages(draftId: string): Promise<void>;
}
